import { useAppSession } from '@/src/contexts/AppSessionContext'

import { useVoiceAssessmentAnalysisReadyToast } from '../hooks/useVoiceAssessmentAnalysisReadyToast'

/**
 * Mount under a layout that wraps {@link AppSessionProvider} so analysis-ready
 * toasts work app-wide (not only on Statistics). Renders nothing.
 *
 * Only fetch sessions on the main account route. Post-payment onboarding still
 * 403s GET /api/session until backend entitlement is ready.
 */
export function VoiceAssessmentAnalysisReadyToastHost() {
  const { accountRoute } = useAppSession()
  const analysisToastEnabled = accountRoute === 'main'

  useVoiceAssessmentAnalysisReadyToast({
    enabled: analysisToastEnabled,
  })
  return null
}
